import * as React from 'react';
import {CallJs} from "../lib/types";
import * as ReactDOM from "react-dom";
import {reduceObj} from "../lib/utils";
import {Button, Type as ButtonType} from "../lib/sbhtml/button";
import * as R from 'ramda'

type Params = { modules: Modules }
type Modules = {[id: string]: string}

export const templateImporter:CallJs<Params> = (replace, params) => {
	const div = document.createElement('div')
	replace(div)

	ReactDOM.render(<Importer modules={params.modules} />, div)
}

const Importer = (params: {modules: Modules}) => {
	const options = reduceObj((id: string, instance: string, acc: JSX.Element[]) => {
		acc.push(<option key={id} value={instance}>{instance}</option>)
		return acc
	}, params.modules, [])
	const keys = R.keys(params.modules)
	return <div>
		<h1>Template Importer</h1>
		<div>Select a module from the list below then hit 'Import' to import the templates from that module into this one.</div>
		<form method='post'>
			<div><select defaultValue={keys[0]} name='contentInstance'>{options}</select></div>
			<div><Button type={ButtonType.submit}>Import</Button></div>
		</form>
	</div>
}



// WEBPACK FOOTER //
// ./src/knowledge2/import.tsx